module.exports = __webpack_public_path__ + "img/template_address.0fb9a50b.jpg";